import { GridColDef } from "@mui/x-data-grid";

function orderColumn(): GridColDef {
    return {
        field: "index",
        sortable: false,
        filterable: false,
        headerName: "",
        width: 35,
        minWidth: 35,
        maxWidth: 35,
        renderCell: ({ api, id }) => {
            // Use `id` from params — this matches the grid row id (including when `getRowId` is not `row.id`,
            // e.g. clinic unassigned passengers use `uniqueIdentifier`).
            const order = api.getRowIndexRelativeToVisibleRows(id);

            return <div className="grid place-content-center h-full  font-medium">{order >= 0 ? order + 1 : ""}</div>;
        },
    };
}

export default orderColumn;
